<template>
  <form-select
    class="special-version-select"
    v-model="val"
    :options="options"
    @change="change"
  ></form-select>
</template>
<script>
export default {
  name: 'special-version-select',
  props: {
    area: String,
    version: Object,
    value: String,
    queryObj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    defaultVersion: String
  },
  model: {
    prop: 'value',
    event: 'setval'
  },
  computed: {
    val: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('setval', newVal)
      }
    }
  },
  data() {
    return {
      options: []
    }
  },

  methods: {
    version2Options(version) {
      let options = []
      for (let key in version) {
        for (let item of version[key]) {
          options.push({
            label: 'V' + item + '(' + key + ')',
            value: item + '|' + key
          })
        }
      }
      return options
    },
    change(newVal) {
      var arr = newVal.split('|')
      if (arr.length > 1) {
        this.$nextTick(() => {
          this.$emit('change', arr[0], arr[1])
        })
      }
    }
  },
  watch: {
    queryObj() {
      //console.log('watch--version', JSON.stringify(this.queryObj))
      this.options = this.version2Options(this.version)
      let defaultOption = this.options[0]
      this.val = null
      if (this.queryObj.packid && this.queryObj.version) {
        const defaultVal = this.queryObj.version + '|' + this.queryObj.packid
        defaultOption = this.options.find((item) => item.value === defaultVal)
      }
      if (defaultOption) {
        this.val = defaultOption.value
        this.$nextTick(() => {
          this.change(this.val)
        })
      }
    }
  }
}
</script>
<style lang="less">
.version-select {
  width: 100px;
}
</style>
